<template>
  <v-col class="px-5">
    <h2>{{ title }}</h2>

    <v-slide-y-transition>
      <ErrorCard
        v-if="error"
        :errorMessage="errorMessage"
        :functionName="errorToRecallFunction"
        @deleteFavourite="deleteFavourite(selectedEventId)"
      />
    </v-slide-y-transition>

    <v-container class="mt-4">
      <template v-for="(event, index) in favourites">
        <v-card :key="`favourite-${index}`" outlined class="mb-3" width="100%">
          <h5 class="text-end px-4 py-2">
            {{ event.Type }}
          </h5>

          <v-row justify="start" class="ma-0">
            <v-col cols="12" md="6" lg="4" class="pa-4">
              <v-img :aspect-ratio="14 / 9" :src="event.PictureUrl" />
            </v-col>
            <v-col cols="12" md="6" lg="8">
              <v-row>
                <v-card-title
                  class="headline ml-2"
                  style="word-break: normal"
                  v-text="event.EventTranslationName || event.Name"
                />
                <v-spacer />
                <v-btn
                  icon
                  class="mt-3 ml-2 mr-5"
                  @click="deleteFavourite(event)"
                >
                  <v-icon color="red">favorite</v-icon>
                </v-btn>
              </v-row>

              <v-card-subtitle
                class="mt-2 ellipsis"
                v-html="event.Description"
                style="max-height: 150px"
              />

              <v-card-actions>
                <v-spacer />
                <v-btn text color="primary" @click="goTo(event)">
                  More info
                </v-btn>
              </v-card-actions>
            </v-col>
          </v-row>
        </v-card>
      </template>
    </v-container>
  </v-col>
</template>

<script>
import uiHelpers from '@/shared/ui_helpers';
import doRequest from '@/api/dssRequest';
import ErrorCard from '../generalComponents/ErrorHandling/ErrorCard';

export default {
  data() {
    return {
      // ErrorCard variables
      error: false,
      errorMessage: this.$translate('FAILED_SAVING_FAVOURITES'),
      errorToRecallFunction: 'deleteFavourite',

      favourites: [],
      selectedEvent: {},
    };
  },
  computed: {
    pgrInfo() {
      return this.$store.getters['Account/partnerGroupDetails'];
    },
    title() {
      if (
        this.pgrInfo != null &&
        this.pgrInfo.FavouritesTitle != null &&
        this.pgrInfo.FavouritesTitle.trim() !== ''
      ) {
        return this.pgrInfo.FavouritesTitle.trim();
      }
      return this.$translate('FAVOURITES');
    },
  },
  mounted() {
    this.getFavourites();
  },
  components: {
    ErrorCard,
  },
  name: 'UserSettingsFavourites',
  mixins: [uiHelpers],
  methods: {
    getFavourites() {
      let payload = {};
      doRequest(
        (response) => {
          let fav = response.data.FavouriteMap;

            if(fav.Events.length > 0){
              fav.Events.forEach((event) =>{
                let events = {
                  Name: event.Name,
                  Description: event.Description,
                  PictureUrl: event.PictureUrl,
                  Type: 'Events',
                  Favourite : true,
                  EventId: event.EventId,
                }
                this.favourites.push(events);
              }) ;
            }

          if(fav.ProductCategories.length > 0){
            fav.ProductCategories.forEach((category) =>{
              let productCategories = {
                Name: category.Name,
                Description: category.Description,
                PictureUrl: category.PictureUrl,
                Type: 'ProductCategory',
                Favourite : true,
                EventId: category.EventId,
                Id: category.Id,
              }
              this.favourites.push(productCategories);
            }) ;
          }

          if(fav.Products.length > 0){
            fav.Products.forEach((product) =>{
              let products = {
                Name: product.Name,
                Description: product.Description,
                PictureUrl: product.PictureUrl,
                Type: 'Products',
                favourite: true,
                EventId: product.EventId,
                Id: product.Id,
                Categories: product.Categories,
              }
              this.favourites.push(products);
            }) ;
          }
         this.favourites = this.favourites.reverse();
        },
        () => {},
        'getFavourites',
        this.$store.getters['auth/userName'],
        payload
      );
    },
    goTo(favourite) {
      if (favourite.Type === 'Events') {
        // route to the event details page
        this.goToPage('EventDetails', {
          event_id: favourite.EventId,
        });
      } else if (favourite.Type === 'Products') {
        // route to the product details page
        // always go to the first category of the product
        const firstElement = 0;
        // route to the details of the product
        this.goToPage('ProductWithCategory', {
          event_id: favourite.EventId,
          category_id: favourite.Categories[firstElement].Id,
          product_id: favourite.Id,
        });
      } else {
        // route to the product list page
        this.goToPage('ProductCategory', {
          event_id: favourite.EventId,
          category_id: favourite.Id,
        });
      }
    },
    deleteFavourite(favourite) {
      let payload = {};
      if (favourite.Type === 'Events') {
        payload = {
          ObjectId: favourite.EventId,
          ObjectType: 'Event',
        };
      } else if (favourite.Type === 'Products') {
        payload = {
          ObjectId: favourite.Id,
          ObjectType: 'Product',
        };
      } else {
        payload = {
          ObjectId: favourite.CategoryId,
          ObjectType: 'Category',
        };
      }
      doRequest(
        () => {
          this.favourites = this.favourites.filter(function (fav) {
            if (favourite.Type === 'Events') {
              return fav.EventId != favourite.EventId;
            } else if (favourite.Type === 'Products') {
              return fav.Id != favourite.Id;
            } else {
              return fav.CategoryId != favourite.CategoryId;
            }
          });
        },
        () => {
          this.error = true;
          this.selectedEvent = favourite;
        },
        'deleteFavourite',
        this.$store.getters['auth/userName'],
        payload
      );
    },
  },
};
</script>

<style scoped lang="scss">
.ellipsis {
  word-break: normal;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
